import {
  Box,
  Button,
  ImageList,
  ImageListItem,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import React, { useState, useEffect } from "react";
import { blueTick, leftArrow } from "../../../assets";
import { NoData } from "../../../components/NoData";
import { nftTempImage } from "../../../constants";
import { onConfirmYieldDistribution } from "../../../contract";
import { useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";
import { conciseAddress } from "../../../utils/formatters";
import {
  getKeyForYieldClaim,
  onYieldDistribution,
} from "../../../utils/wallet/apiHelpers";
import { SearchAndView } from "./SearchAndView";
import { StatusTab } from "./StatusTab";
import { NftPreviewCard } from "./NftPreviewCard";

const StyledButton = styled(Button)(({ theme, colors, selected, width }) => ({
  backgroundColor: selected ? colors.primary[500] : colors.whiteAccent[900],
  color: selected ? colors.whiteAccent[900] : colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: width ? width : "94%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const CollectionBox = ({
  collectionName,
  guildName,
  collectionAddress,
  nfts,
  setStep,
  setCurrNfts,
  collectionSelected,
  setCollectionSelected,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        width: "422px",
        height: "484px",
        borderRadius: "14px",
        boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
        background: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
      }}
      onClick={() => {
        setCurrNfts(nfts);
        setStep(1);
      }}
      gridColumn="span 5"
    >
      <ImageList
        sx={{ width: 390, height: 313, margin: 0 }}
        cols={4}
        // rowHeight={"101px"}
        // onClick={() => setStep(1)}
      >
        {nfts.map((item, index) => (
          <ImageListItem key={index} sx={{ height: "100px !important" }}>
            <img
              src={item.image}
              srcSet={item.image}
              onError={(e) => (e.currentTarget.src = nftTempImage)}
              alt={"item.title"}
              loading="lazy"
              style={{
                width: "90px",
                height: "101px",
                borderRadius: "5px",
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      <Box display="flex" flexDirection="row" width={"93%"}>
        <Typography
          variant="overline"
          color={colors.black[500]}
          fontWeight={500}
          //   pl={1}
        >
          {collectionName}
        </Typography>
        <img src={blueTick} alt={"blue tick"} style={{ marginLeft: "5px" }} />
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width={"93%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          //   pl={1}
        >
          Account Name
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {guildName}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        width={"93%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          //   pl={1}
        >
          Account Address
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {conciseAddress(collectionAddress)}
        </Typography>
      </Box>

      <StyledButton
        onClick={(e) => {
          e.stopPropagation();
          if (collectionSelected === collectionAddress) {
            setCollectionSelected("");
          } else {
            setCollectionSelected(collectionAddress);
          }
        }}
        variant="outlined"
        colors={colors}
        selected={collectionSelected === collectionAddress}
      >
        {/* {currNft.selected ? "Selected" : "Select"} */}
        {collectionSelected === collectionAddress ? "Selected" : "Select"}
      </StyledButton>
    </Box>
  );
};

export const Borrowed = ({ currStatus, setCurrStatus, collapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account } = useWeb3React();
  const [step, setStep] = useState(0);
  const [currNfts, setCurrNfts] = useState([]);
  const { setLoading, setSnackbar } = useUIActions();
  const { borrowedNfts, collectionWiseBorrowedNfts } = useTypedSelector(
    (state) => state.apiReducer
  );

  const [collectionSelected, setCollectionSelected] = useState("");

  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downLg = useMediaQuery(theme.breakpoints.down("lg"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));
  const NftBoxProps = () => {
    if (downMd && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "30px",
      };
    } else if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",
        gap: "30px",
      };
    } else if (downLg && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",
        gap: "30px",
      };
    } else if (downLg) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",
        gap: "30px",
      };
    } else if (downXl && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",
        gap: "30px",
      };
    } else if (downXl) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl || !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    }
  };

  const onClaimCallback = async (msg, status) => {
    setLoading(false);
    setSnackbar({
      open: true,
      severity: status ? "success" : "error",
      message: msg,
    });
    setCollectionSelected("");
  };

  const onClaim = async () => {
    try {
      setLoading(true);
      let nftsToClaimYieldOn = collectionWiseBorrowedNfts.filter(
        (col) => col.address === collectionSelected
      )[0].nfts;

      console.log("nftsToClaimYieldOn", nftsToClaimYieldOn);

      const resp = await getKeyForYieldClaim(account, "EMBER_BORROWER", "");
      console.log("resp for key", resp);
      const finalResp = await onYieldDistribution(
        resp,
        nftsToClaimYieldOn[0].lender.id.toLowerCase(),
        account.toLowerCase(),
        nftsToClaimYieldOn[0].rewardTokenAddress.toLowerCase()
      );
      console.log("finalResp", finalResp);
      if (finalResp?.payload?.hash) {
        await onConfirmYieldDistribution(
          finalResp?.payload?.hash,
          onClaimCallback
        );
      } else {
        onClaimCallback(
          finalResp?.payload?.msg || "Something went wrong!",
          false
        );
      }
    } catch (e) {
      console.log("error on claim", e);
      setLoading(false);
    }
  };

  const NftBoxProps2 = () => {
    if (downMd && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",

        gap: "30px",
      };
    } else if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl || !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(20, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(25, 1fr)",
        gap: "30px",
      };
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        paddingBottom: "20px",
      }}
      gap="10px"
    >
      <SearchAndView option={false} />

      <StatusTab currStatus={currStatus} setCurrStatus={setCurrStatus} />
      {step === 0 ? (
        <>
          {collectionWiseBorrowedNfts.length > 0 ? (
            <Box {...NftBoxProps()}>
              {collectionWiseBorrowedNfts.map((item, index) => (
                <CollectionBox
                  collectionName={item.contractMetadata.name}
                  guildName={"Name Sad"}
                  collectionAddress={item.address}
                  nfts={item.nfts}
                  setStep={setStep}
                  setCurrNfts={setCurrNfts}
                  collectionSelected={collectionSelected}
                  setCollectionSelected={setCollectionSelected}
                />
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <NoData text="No Nft to show!" />
            </Box>
          )}

          <Box
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            marginTop={"50px"}
          >
            <StyledButton
              onClick={() => onClaim()}
              variant="outlined"
              colors={colors}
              width={"272px"}
              disabled={
                collectionWiseBorrowedNfts.length === 0 ||
                collectionSelected.length === 0
              }
            >
              Claim Yield
            </StyledButton>
          </Box>
        </>
      ) : (
        <>
          <img
            src={leftArrow}
            alt="left arrow"
            style={{ marginLeft: "15px" }}
            onClick={() => setStep(0)}
          />

          <Box {...NftBoxProps2()} style={{ marginLeft: "15px" }}>
            {currNfts.map((item, index) => (
              <Box gridColumn="span 5" gridRow="span 3">
                <NftPreviewCard
                  image={item.image}
                  collectionName={item.contractName}
                  tokenId={item.tokenId}
                  status={item.status}
                  key={index}
                  address={item.nftAddress}
                />
              </Box>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};
